export default "__VITE_ASSET__lYDqWCKk__"